export default {
  not_set_up: {
    title: 'Rezerwacje nie są jeszcze skonfigurowane dla tej lokalizacji',
    description:
      'Lokalizacja otrzymuje rezerwacje dopiero gdy zostanie połączona z wizytówką Google i ma właściciela. Jeśli restauracja nie ma jeszcze właściciela, dodaj go w zakładce Zespół. Do tego czasu nie ma tu godzin otwarcia rezerwacji do edycji, a zmiany godzin w Sklepie online nie są kopiowane do Rezerwacji.',
  },
  company_not_loaded: {
    title: 'Nie udało się wczytać ustawień rezerwacji',
    description:
      'Nie udało się wczytać ustawień rezerwacji dla tej lokalizacji, więc jej godziny otwarcia dla rezerwacji nie mogą być teraz edytowane. Spróbuj ponownie.',
    retry: 'Spróbuj ponownie',
  },
};
